import successIcon from '../assets/icon/success_icon.png'
import errorIcon from '../assets/icon/error_icon.png'
import * as FileSaver from 'file-saver'
import { Button, Modal } from 'antd'
import * as XLSX from 'xlsx'
import draftToHtml from 'draftjs-to-html'
import { convertToRaw } from 'draft-js'

export const formatNumber = num => {
  if (num !== undefined) {
    return parseFloat(Number(num).toFixed(2))
      .toString()
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }
  return 0
}

export const getHtml = editorState => draftToHtml(convertToRaw(editorState.getCurrentContent()));


export const formatCurrency = (value, currency) =>
  new Intl.NumberFormat(`en-${currency?.slice(0, 2) || "NG"}`, {
    style: "currency",
    currency: currency || "NGN",
  }).format(value).replace(".00","");

  export const handleDataExport = (name, parseData) => {
    const ws = XLSX.utils.json_to_sheet(parseData)
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
    const data = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    })
    FileSaver.saveAs(data, `${name}.xlsx`)
  }
  
  export const handleDataReduce = (data, key) => {
    return data?.reduce((a, b) => Number(a) + Number(b?.[key] || b), 0)
  }

  export const handleHash = (data, index) => {
    const mailName = String(data||"")?.slice(0,String(data||"")?.indexOf("@") || index)
    const mailProvider = String(data||"")?.slice(String(data||"")?.indexOf("@") || index)
    const mailNameCut = mailName.slice(0, Math.floor(mailName.length/2))
    return mailNameCut.padEnd(mailName.length, "*").concat(mailProvider) || ""
  }

  export const handleShrink = (data) => <p className='w-10 truncate' title={data}>{handleHash(data, data?.length/2)}</p>

  export const handleCapitalize = (data) => {
    return String(data||"")?.charAt(0)?.toUpperCase() + String(data||"")?.slice(1);
  }

  export function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (err) => reject(err);
    });
  }

export function getBinary(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const data=(reader.result).split(',')[1];
      resolve(atob(data));
    }
    reader.onerror = (err) => reject(err)
  })
}

export const statusType = {
  secondary: { col: "!text-[#3E4A5F]", bg: "!bg-[#878A991F]", bd: "!border !border-[#495057]", },
  pending: { col: "!text-[#FFBD00]", bg: "!bg-[#FFBD001F]",  bd: "!border !border-[#FFBD00]" },
  inactive: { col: "!text-[#E01020]", bg: "!bg-[#E010201F]", bd: "!border !border-[#E01020]" },
  success: { col: "!text-[#12B76A]", bg: "!bg-[#ECFDF3]", bd: "!border !border-[#12B76A]" },
  error: { col: "!text-[#E01020]", bg: "!bg-[#E010201F]", bd: "!border !border-[#E01020]" },
  active: { col: "!text-[#12B76A]", bg: "!bg-[#ECFDF3]", bd: "!border !border-[#12B76A]" },
  info: { col: "!text-[#004EC4]", bg: "!bg-[#E6EDF9]", bd: "!border !border-[#004EC4]" },
}

export const handleTableSelect = (data, setData, key) => ({
    type: "checkbox",
    selectedRowKeys: data,
    onChange: (e, selectedRows) => {
      const arr = [];
      selectedRows.forEach(row => arr.push(row?.[key] || row));
      setData(arr);
    },
})

export const successModal = ({
  icon,
  title,
}) => {
  Modal.success({
    footer: false,
    icon: <span />,
    closeIcon: false,
    maskClosable: true,
    className: 'md:!w-[350px] rounded-lg bg-white !min-h-[350px] !relative px-10',
    content: (<div className='flex flex-col justify-center items-center text-center gap-5 absolute left-0 right-0'>
      <div>{icon || <img alt='error icon' src={successIcon} />}</div>
      <p className='text-2xl font-bold text-light_blue'>{title || "Saved"}</p>
    </div>)
  });
};

export const handleConfirm = ({
  data,
  icon,
  title,
  action,
  loading,
  description,
}) => {
  const onClose = () => Modal.destroyAll()
  const handleAction = () => {
    action(data);
    onClose();
  }
  Modal.confirm({
    footer: false,
    icon: <span />,
    closeIcon: false,
    maskClosable: true,
    className: 'md:!w-[350px] rounded-lg bg-white !min-h-[350px] !relative px-10',
    content: (<div className='flex flex-col justify-center items-center text-center gap-5 absolute left-0 right-0'>
      <div>{icon || <img alt='error icon' src={errorIcon} />}</div>
      <p className='text-lg font-bold text-[#3E4A5F]'>{title || "Are you sure you want to delete this data?"}</p>
      <p className='text-sm font-normal text-[#596476]'>{description || "data to delete."}</p>
      <div className='w-full grid grid-cols-2 gap-3'>
        <Button onClick={onClose} className='!text-[#3E4A5F] !border-light_blue' size='large'>Cancel</Button>
        <Button onClick={handleAction} loading={loading} size='large' type='primary' danger>Delete</Button>
      </div>
    </div>)
  });
};

export const stringify = (data) => JSON.stringify(data)

export const parse = (data) => JSON.parse(data)

export const realObject = (data) => Object.fromEntries(Object.entries(data || {}).filter(([,value]) => value))

export const include = (data, key) => data?.includes(key)

export const isEqual = (data, key) => (data === key)

export const handlePrint = () => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' }
  const moment = (date) => new Date(date || new Date()).toLocaleDateString("en-US", options)
  const printWindow = window.open("mardi-gras.com", "_blank", "toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no, width=2000, height=1000, visible=none");
  printWindow?.document.write(`
    <!DOCTYPE html>
    <html lang="en">
      <head>
        <meta charset="UTF-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>INVOICE</title>

        <script src="https://cdn.tailwindcss.com"></script>

        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous" />

        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link href="https://fonts.googleapis.com/css2?family=Figtree:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet" />

        <style>
          *{"font-family": 'Figtree', sans-serif}
        </style>
      </head>
      <body>
        <div className='print:space-y-5'>
          <div className='print:flex print:flex-col print:gap-3 print:justify-center print:items-center print:text-center'>
            <img
              alt='logo'
              className='print:w-[150px] print:md:w-auto print:max-w-[180px]'
              src="https://mardi-gras-admin.surge.sh/static/media/logo.d1a104195a66b316605f74143db5c240.svg"
            />
            <p className='text-xs font-normal text-[#101828]'>KC100, 5/F, 100 Kwai Cheong Rd, <br /> Kwai Chung, Hong Kong</p>
            <p className='text-xs font-normal text-[#101828] flex gap-2 items-center'>
              <a href='tel:+2347091237564'>+234 709 123 7564</a>
              <a href='mailto:+support@mardi-gras.com'>support@mardi-gras.com</a>
            </p>
          </div>
          <div className='w-full p-5 bg-[#F2F5F9] space-y-10'>
            <div className='flex flex-col md:flex-row justify-between gap-5'>
              <p className='text-xl font-bold text-[#121722]'>Invoice</p>
              <div className='space-y-2'>
                <p className='text-xs font-normal text-[#60737D]'>Invoice No.</p>
                <p className='text-sm font-bold text-[#121722]'>#000123</p>
              </div>
            </div>
            <div className='flex flex-col md:flex-row justify-between gap-5'>
              <div className='space-y-2.5'>
                <p className='text-xs font-normal text-[#60737D]'>Billed To:</p>
                <p className='text-sm font-semibold text-[#121722]'>Allen Francis</p>
                <p className='text-xs font-normal text-[#121722]'>8 Olalusi Street, Owode Onirin, Ikorodu Road</p>
                <p className='text-xs font-normal text-[#121722]'>+234 709 123 7564</p>
              </div>
              <div className='space-y-3 md:text-end'>
                <div className='space-y-1.5'>
                  <p className='text-xs font-normal text-[#60737D]'>Issued on</p>
                  <p className='text-xs font-semibold text-[#121722]'>${moment()}</p>
                </div>
                <div className='space-y-1.5'>
                  <p className='text-xs font-normal text-[#60737D]'>Payment Date</p>
                  <p className='text-xs font-semibold text-[#121722]'>${moment()}</p>
                </div>
              </div>
            </div>
          </div>
          <div className='space-y-20'>
            <div className='whitespace-nowrap overflow-auto'>
              <table class="table table-borderless">
                <thead>
                  <tr>
                    <th scope="col"><p className='text-sm font-bold text-[#101828]'>Item</p></th>
                    <th scope="col">Payment Method</th>
                    <th scope="col">Qty</th>
                    <th scope="col">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Men Shirt</td>
                    <td>Paystack</td>
                    <td>1</td>
                    <td>${formatNumber(4000)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <hr
              orientation="right"
              orientationMargin="0"
            >
              <div className='bg-[#F2F5F9] flex justify-between items-center gap-20 rounded-xl px-5 py-3'>
                <p className='text-xs font-normal text-[#101828]'>Total ( NGN )</p>
                <p className='text-base font-bold text-[#101828]'>${formatNumber(8000)}</p>
              </div>
            </hr>
            <p className='text-base font-normal text-[#101828] text-center'>Thank you for your order. Come  Again...!</p>
          </div>
        </div>
      </body>
    </html>
  `);
  printWindow?.document.close();
  printWindow?.print();
};
